export async function wordPressRequest(method = "POST", url = "", data) {
	// Default options are marked with *
	const response = await fetch(url, {
		method: method, // *GET, POST, PUT, DELETE, etc.
		credentials: "same-origin", // include, *same-origin, omit
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
			"Cache-Control": "no-cache",
		},
		body: data, // body data type must match "Content-Type" header
	});

	return response.json(); // parses JSON response into native JavaScript objects
}
